import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { environment } from '../../../environment';
import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const ThirdPartyForm_NafEntries_QueryDocument = graphql(`
  query ThirdPartyForm_NafEntries_Query {
    findAllActiveNafEntries {
      _id
      code
      designation
      version
    }
  }
`);

export type ThirdPartyForm_NafEntry = ResultOf<
  typeof ThirdPartyForm_NafEntries_QueryDocument
>['findAllActiveNafEntries'][number];

export const useNafEntriesQuery = () =>
  useGraphQLQuery(ThirdPartyForm_NafEntries_QueryDocument, undefined, {
    gcTime: environment.referenceQueryGcTime,
    staleTime: environment.referenceQueryStaleTime,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
